const store = new Vuex.Store({
    modules: {
        Global: Global.store,
        Layout: Layout.store,
        ManageProperties: ManageProperties.store,
        ManageAccount: ManageAccount.store,
        Properties: Properties.store,
    }
});